<template>
  <register-user-callback />
</template>
      
  <script>
import RegisterUserCallback from "../components/register-user-callback/Index.vue";

export default {
  name: "Login",
  components: {
    RegisterUserCallback,
  },
  data: () => ({}),
};
</script>
      
  <style>
</style>